<template>
  <div class="page-container flex-row">
    <div class="col-0 page_container_nav">
      <div class="page_container_nav_item page_container_nav_item_active" @click="$router.push('/report')">
        推荐报告制作
      </div>
      <div class="page_container_nav_item" @click="$router.push('/lists')">list制作</div>
      <div class="page_container_nav_item" @click="$router.push('/createcompany')">建立公司知识库</div>
    </div>
    <div class="flex-column col-1">
      <div class="col-1 flex-column scroll">
        <el-table ref="table" v-loading="loading" class="scroll" :data="list" border size="mini">
          <el-table-column type="index" align="center" width="45" />
          <el-table-column label="完成" align="center" width="45">
            <template slot-scope="scope">
              <i
                :class="`el-icon-success pointer ${scope.row.finish ? 'ft-green' : ''}`"
                @click="finishReport(scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column width="160" label="操作" align="center">
            <template slot-scope="scope">
              <a href="javascript:void(0);" class="mr5" @click="makeReport(scope.row)">在线制作</a>
              <a href="javascript:void(0);" class="mr5" @click="upload(scope.row)">上传报告</a>
              <a :id="scope.row.rid + ''" href="javascript:void(0);" @click="showFiles(scope.row.rid)">附件</a>
            </template>
          </el-table-column>
          <el-table-column label="参考附件">
            <template slot-scope="scope">
              <a class="mr5" @click="preview(scope.row)">{{ scope.row.originalname || '--' }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="sender" label="发送人" />
          <el-table-column label="人选">
            <template slot-scope="scope">
              <a href="javascript:void(0);" @click="showRadish(scope.row.rid)">{{ scope.row.name }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="company" label="公司" />
          <el-table-column prop="department" label="部门" />
          <el-table-column prop="project" label="项目" />
          <el-table-column label="时间" width="100">
            <template slot-scope="scope">{{ dateFormat(new Date(scope.row.createdAt), 'yyyy-mm-dd') }}</template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        :current-page="page"
        :page-sizes="[100, 200, 500]"
        :page-size="pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        class="col-0"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      />
      <UploadDialog ref="upload" :on-success="uploadSuccess" :on-error="onError" type="推荐报告" label="推荐报告" />
      <Popper :visible.sync="popperVisible" :target-id="popperTarget" class-name="shadow">
        <FileTable :rid="popperTarget" :files="files" :paginate="false" :on-delete="onDelete" width="700px" />
      </Popper>
    </div>
  </div>
</template>

<script>
import { FileTable } from '../../../file'
import Popper from '../components/Popper.vue'
import { preview } from '../constant/utils.js'

const dateFormat = require('dateformat')

export default {
  components: { Popper, FileTable },
  data() {
    return {
      list: [],
      page: 1,
      pageSize: 100,
      total: 0,
      loading: false,
      files: [],
      popperVisible: false,
      popperTarget: '',
    }
  },
  computed: {
    dateFormat() {
      return dateFormat
    },
    preview() {
      return preview
    },
  },
  async mounted() {
    await this.getData()
  },
  methods: {
    showRadish(id) {
      if (!id) return
      window.open(`${window.frontend}/#/radish-detail-blank/${id}`, '_blank')
    },
    async getData() {
      if (this.loading) return
      const { page, pageSize } = this
      this.loading = true
      try {
        const { data, total } = await window.app.service('recommendReport').find({
          query: {
            $skip: (page - 1) * pageSize,
            $limit: pageSize,
            $sort: {
              createdAt: -1,
            },
          },
        })
        this.total = total
        this.list = data
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    pageSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    pageChange(val) {
      this.page = val
      this.getData()
    },
    async makeReport(item) {
      try {
        const ref = window.app.root.$refs.cvPreview
        await ref.getFile(item)
      } catch (e) {
        console.error(e)
      }
      app.root.$refs.ReportTemplateV2.init({
        rid: item.rid, pid: item.pid, md5: item.md5, templateId: (item.spTemplate && item.spTemplate._id) ? item.spTemplate._id: '',
        recommendReportId: item._id, onFinishReport: this.finishReport
      })
    },
    upload(item) {
      this.rid = item.rid
      this.$refs.upload && this.$refs.upload.visible(true)
    },
    onError(err, file, fileList) {
      if (err) {
        this.$message.error(err.message)
      }
    },
    async finishReport(row) {
      if (this.updating || row.finish) return
      this.updating = true
      try {
        console.log('patch: ', row._id)
        if (Object.keys(row).length > 1) {
          await window.app.service('recommendReport').patch(row._id, {
            finish: true,
            pendingPush: true,
          })
        }
        this.getData()
      } catch (error) {
        console.log(error)
        this.$message.error(error.stack)
      }
      this.updating = false
    },
    async uploadSuccess(response) {
      const attachment = Object.assign({}, { uploader: window.app.user.account, rid: this.rid }, response[0])
      await window.app.service('radish').addAttachment(attachment)
    },
    async showFiles(rid) {
      const { data } = await app.service('file').radishFiles({
        query: { rid },
      })
      this.files = data
      this.popperTarget = `${rid}`
      this.popperVisible = true
    },
    onDelete(file) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          window.app.service('project').removeRadishFile(file.fileId)
        })
        .catch(() => {})
    },
  },
}
</script>

<style>
@import '../css/main.css';
</style>
